module.exports = __webpack_public_path__ + "f2be33d3d2ebd7fb41dfa50d1e9499e1.svg";